module.exports = __webpack_public_path__ + "static/feature_wages-bdf309dea7ad7590fb90ed7eb5918439.png";